module.exports = __webpack_public_path__ + "static/media/brahma_01.de6871be.png";